// import React from 'react';
// import { images } from '../../constants';
// import {IconScroll} from '../../components';
// import './Hero.css';


// const logos = ["logo01", "logo02", "logo03", "logo04", "logo05"];

// const Hero = () => {

//   return (
//     <div className="hero">
//       <div className="row align-items-center">
//         <div className="col-md-6 col-12">
//           <h1 className="title"> Dominate Ai before you dominated by it </h1>
//           <p className="py-4">Our goal is to nurture the new generation that will build the nation and lead the world through the power of Artificial Intelligence (AI), as it continues to shape the future...</p>
//           <button className="btn-positivus">We provide to Gen Z...</button>
//         </div>
//         <div className="col-md-6 col-12 mt-md-0 mt-4">
//           <img className="img-fluid" src={images.hero} alt="design" />
//         </div>
//       </div>
      
//       <div className="clients">
//       {logos.map((logo, index) => (
//       <img
//         key={index}
//         src={images[logo]}
//         alt={images[logo]}
//       />
//     ))}
  
//       </div>
//       <IconScroll />
//     </div>
    
//   )
// }

// export default Hero






// import React, { useState, useEffect } from 'react';
// import { images } from '../../constants';
// import { IconScroll } from '../../components';
// import './Hero.css';

// const logos = ["logo01", "logo02", "logo03", "logo04", "logo05"];
// const heroImages = [images.hero, images.hero1, images.hero2, images.hero3, images.hero4, images.hero5];

// const Hero = () => {
//   const [currentImageIndex, setCurrentImageIndex] = useState(0);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentImageIndex((prevIndex) => (prevIndex + 1) % heroImages.length);
//     }, 2000);

//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <div className="hero">
//       <div className="row align-items-center">
//         <div className="col-md-6 col-12">
//           <h1 className="title"> Dominate Ai before you dominated by it </h1>
//           <p className="py-4">
//             Our goal is to nurture the new generation that will build the nation and lead the world through the power of Artificial Intelligence (AI), as it continues to shape the future...
//           </p>
//           <button className="btn-positivus">We provide to Gen Z...</button>
//         </div>
//         <div className="col-md-6 col-12 mt-md-0 mt-4">
//           <img
//             className="img-fluid"
//             src={heroImages[currentImageIndex]}
//             alt="design"
//           />
//         </div>
//       </div>

//       <div className="clients">
//         {logos.map((logo, index) => (
//           <img
//             key={index}
//             src={images[logo]}
//             alt={images[logo]}
//           />
//         ))}
//       </div>
      
//       <IconScroll />
//     </div>
//   );
// }

// export default Hero;


import React, { useState, useEffect } from 'react';
import { images } from '../../constants';
import { IconScroll } from '../../components';
import './Hero.css';

const logos = ["logo01", "logo02", "logo03", "logo04", "logo05"];
const heroImages = [images.hero, images.hero1, images.hero2, images.hero3, images.hero4, images.hero5, images.hero6];

const Hero = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [direction, setDirection] = useState(1); // 1 = forward, -1 = backward

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => {
        if (prevIndex === heroImages.length - 1) {
          setDirection(-1); // if last image, go backward
          return prevIndex - 1;
        } else if (prevIndex === 0) {
          setDirection(1); // if first image, go forward
          return prevIndex + 1;
        } else {
          return prevIndex + direction;
        }
      });
    }, 3000);

    return () => clearInterval(interval);
  }, [direction]);

  return (
    <div className="hero">
      <div className="row align-items-center">
        <div className="col-md-6 col-12">
          <h1 className="title"> Dominate Ai before you dominated by it </h1>
          <p className="py-4" style={{color:'blue', fontWeight:'bold'}}>
            Our goal is to nurture the new generation that will build the nation and lead the world through the power of Artificial Intelligence (AI), as it continues to shape the future...
          </p>
          <button className="btn-positivus">We provide to Gen Z...</button>
        </div>

        <div className="col-md-6 col-12 mt-md-0 mt-4">
          <div className="image-slider">
            <div
              className="image-slider-track"
              style={{
                transform: `translateX(-${currentImageIndex * 100}%)`,
                transition: 'transform 1s ease-in-out',
              }}
            >
              {heroImages.map((img, index) => (
                <img
                  key={index}
                  className="img-fluid slider-image"
                  src={img}
                  alt={`hero${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* <div className="clients">
        {logos.map((logo, index) => (
          <img
            key={index}
            src={images[logo]}
            alt={images[logo]}
          />
        ))}
      </div> */}



      <div className="clients">
        <div className="marquee">
          <div className="marquee-track">
            {logos.map((logo, index) => (
              <img
                key={index}
                src={images[logo]}
                alt={images[logo]}
                className="marquee-logo"
              />
            ))}
            {/* Repeat logos again for smooth infinite scroll */}
            {logos.map((logo, index) => (
              <img
                key={`repeat-${index}`}
                src={images[logo]}
                alt={images[logo]}
                className="marquee-logo"
              />
            ))}
          </div>
        </div>
      </div>



      <IconScroll />
    </div>
  );
};

export default Hero;
